(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["torrins-card-media-groups"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.torrinsCardMediaGroups) return;
    window.torrinsCardMediaGroups = true;

    /** @param {Element} slide - the variant-image slide that just became visible */
    const showGroup = (slide) => {
      const slideshow = slide.closest('slideshow-component');
      const owner = slide.getAttribute('slide-id');
      if (!slideshow || !owner) return;
      for (const other of slideshow.querySelectorAll('slideshow-slide[data-torrins-group]')) {
        if (other.hasAttribute('variant-image')) continue;
        const group = other.getAttribute('data-torrins-group');
        const show = group === 'all' || group === owner;
        if (other.hidden === show) other.hidden = !show;
      }
    };

    new MutationObserver((records) => {
      for (const record of records) {
        const slide = record.target;
        if (
          slide instanceof HTMLElement &&
          slide.matches('product-card slideshow-slide[variant-image][data-torrins-group]') &&
          !slide.hidden
        ) {
          showGroup(slide);
        }
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['hidden'], subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["torrins-cart-recs-assets"] && !Shopify.designMode) return;
  try {
    // Delegated on document so it keeps working when Horizon re-renders the cart (morph) and when the
  // suggestions appear after a cart change without a page load.
  if (!window.torrinsCartRecsBound) {
    window.torrinsCartRecsBound = true;

    // Variant dropdown: show the selected variant's price (pre-formatted on the option).
    document.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-cart-recs-variant]')) return;
      const option = select.selectedOptions[0];
      const card = select.closest('[data-cart-recs-card]');
      if (!option || !card) return;

      const price = card.querySelector('[data-cart-recs-price]');
      const compare = card.querySelector('[data-cart-recs-compare]');
      if (price) price.textContent = option.dataset.price || '';
      if (compare instanceof HTMLElement) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
    });

    document.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-cart-recs-add]') : null;
      if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;
      event.preventDefault();

      const card = button.closest('[data-cart-recs-card]');
      const field = card?.querySelector('[data-cart-recs-variant]');
      const variantId = field instanceof HTMLSelectElement || field instanceof HTMLInputElement ? field.value : '';
      if (!variantId) return;

      const error = button.closest('torrins-cart-recommendations')?.querySelector('[data-cart-recs-error]');
      if (error instanceof HTMLElement) error.hidden = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        // Reload so the cart (lines, discounts, totals) and the suggestions re-render.
        window.location.reload();
      } catch (err) {
        if (error instanceof HTMLElement) {
          error.textContent = err instanceof Error ? err.message : String(err);
          error.hidden = false;
        }
        button.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["torrins-compare-toggle"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.TorrinsCompare) return;

    const KEY = 'torrins-compare';
    const MAX = 4;
    const labels = { soldOut: 'Sold out', add: 'Add to cart' };

    const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
    const notify = () => document.dispatchEvent(new CustomEvent('torrins:compare-change'));

    const TorrinsCompare = {
      max: MAX,

      /** @returns {{handle: string, title: string, url: string, image: string}[]} */
      read() {
        try {
          const list = JSON.parse(localStorage.getItem(KEY) || '[]');
          return Array.isArray(list) ? list.filter((item) => item && item.handle).slice(0, MAX) : [];
        } catch {
          return [];
        }
      },

      write(list) {
        try {
          localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
        } catch {}
        notify();
      },

      has(handle) {
        return this.read().some((item) => item.handle === handle);
      },

      /**
       * Collections every product in the list shares ({h, t}[]); null when no product has collection info.
       */
      sharedCollections(list = this.read()) {
        let shared = null;
        for (const entry of list) {
          if (!Array.isArray(entry.collections) || entry.collections.length === 0) continue;
          shared = shared ? shared.filter((c) => entry.collections.some((e) => e.h === c.h)) : [...entry.collections];
        }
        return shared;
      },

      /** The product shares a collection with the list (missing collection info never blocks). */
      fits(item, list = this.read()) {
        const shared = this.sharedCollections(list);
        if (!shared || !Array.isArray(item.collections) || item.collections.length === 0) return true;
        return shared.some((c) => item.collections.some((e) => e.h === c.h));
      },

      /** @returns {'added' | 'full' | 'collection'} */
      add(item) {
        const list = this.read();
        if (list.some((entry) => entry.handle === item.handle)) return 'added';
        if (!this.fits(item, list)) return 'collection';
        if (list.length >= MAX) return 'full';
        list.push(item);
        this.write(list);
        return 'added';
      },

      /** Start a new list with this product (used when a product from another collection is picked). */
      replace(item) {
        this.write([item]);
      },

      remove(handle) {
        this.write(this.read().filter((item) => item.handle !== handle));
      },

      clear() {
        this.write([]);
      },

      open() {
        ensurePopup().open();
      },
    };
    window.TorrinsCompare = TorrinsCompare;

    /* ---------- Compare bar ---------- */
    class TorrinsCompareBar extends HTMLElement {
      connectedCallback() {
        this.className = 'torrins-compare-bar';
        this.setAttribute('role', 'region');
        this.setAttribute('aria-label', 'Compare products');
        this.addEventListener('click', this.#onClick);
        document.addEventListener('torrins:compare-change', this.render);
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('torrins:compare-change', this.render);
      }

      /** A product of another type was picked: ask to replace the current list. */
      askReplace(item) {
        this.pending = item;
        this.render();
        this.querySelector('[data-compare-replace]')?.focus();
      }

      showMessage(text) {
        const message = this.querySelector('[data-compare-message]');
        if (!message) return;
        message.textContent = text;
        clearTimeout(this.messageTimer);
        this.messageTimer = setTimeout(() => (message.textContent = ''), 4000);
      }

      #onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const remove = target?.closest('[data-compare-remove]');
        if (remove instanceof HTMLElement) TorrinsCompare.remove(remove.dataset.compareRemove || '');
        if (target?.closest('[data-compare-clear]')) TorrinsCompare.clear();
        if (target?.closest('[data-compare-open]')) TorrinsCompare.open();
        if (target?.closest('[data-compare-replace]') && this.pending) {
          const item = this.pending;
          this.pending = null;
          TorrinsCompare.replace(item);
        }
        if (target?.closest('[data-compare-cancel]')) {
          this.pending = null;
          this.render();
        }
      };

      render = () => {
        const list = TorrinsCompare.read();
        this.hidden = list.length === 0;
        if (this.hidden) {
          this.pending = null;
          return;
        }

        const slots = [];
        for (let i = 0; i < MAX; i++) {
          const item = list[i];
          if (!item) {
            slots.push('<li class="torrins-compare-bar__item" aria-hidden="true"></li>');
            continue;
          }
          const title = escapeHtml(item.title);
          slots.push(`
            <li class="torrins-compare-bar__item torrins-compare-bar__item--filled" title="${title}">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${title}" width="56" height="56" loading="lazy">` : ''}
              <button type="button" class="torrins-compare-bar__remove" data-compare-remove="${escapeHtml(item.handle)}" aria-label="Remove ${title}">&times;</button>
            </li>`);
        }

        const message = this.querySelector('[data-compare-message]')?.textContent || '';
        const ready = list.length >= 2;
        const shared = TorrinsCompare.sharedCollections(list) || [];
        const group = shared[0]?.t || '';
        const pending = this.pending;
        const prompt = pending
          ? `<div class="torrins-compare-bar__prompt" role="alertdialog" aria-label="Replace compare list">
              <p>You can only compare products from the same collection. Replace your ${escapeHtml(group || 'current')} list with
                <strong>${escapeHtml(pending.title)}</strong>?</p>
              <div class="torrins-compare-bar__prompt-actions">
                <button type="button" class="torrins-compare-bar__replace" data-compare-replace>Replace</button>
                <button type="button" class="torrins-compare-bar__cancel" data-compare-cancel>Cancel</button>
              </div>
            </div>`
          : '';
        this.innerHTML = `
          <div class="torrins-compare-bar__inner">
            ${prompt}
            <ul class="torrins-compare-bar__items" role="list">${slots.join('')}</ul>
            <div>
              <p class="torrins-compare-bar__text">${ready ? `${list.length} products selected` : 'Select at least 2 products to compare'}</p>
              ${group ? `<p class="torrins-compare-bar__type">Comparing: ${escapeHtml(group)}</p>` : ''}
              <p class="torrins-compare-bar__message" data-compare-message role="status">${escapeHtml(message)}</p>
            </div>
            <div class="torrins-compare-bar__actions">
              <button type="button" class="torrins-compare-bar__clear" data-compare-clear>Clear all</button>
              <button type="button" class="torrins-compare-bar__go" data-compare-open ${ready ? '' : 'disabled'}>Compare now (${list.length})</button>
            </div>
          </div>`;
      };
    }

    /* ---------- Full-screen compare popup ---------- */
    class TorrinsComparePopup extends HTMLElement {
      cache = new Map();

      connectedCallback() {
        this.innerHTML = `
          <dialog class="torrins-compare-popup" aria-labelledby="TorrinsCompareTitle">
            <div class="torrins-compare-popup__header">
              <h2 class="torrins-compare-popup__title" id="TorrinsCompareTitle">Compare products</h2>
              <button type="button" class="torrins-compare-popup__close" data-compare-close aria-label="Close">&times;</button>
            </div>
            <div class="torrins-compare-popup__body">
              <div data-compare-content></div>
              <p class="torrins-compare-popup__error" role="alert" data-compare-error></p>
            </div>
          </dialog>`;
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[data-compare-content]');
        this.error = this.querySelector('[data-compare-error]');
        this.addEventListener('click', this.#onClick);
        document.addEventListener('torrins:compare-change', this.#onStoreChange);
      }

      disconnectedCallback() {
        document.removeEventListener('torrins:compare-change', this.#onStoreChange);
      }

      async open() {
        if (!this.dialog || !this.content) return;
        if (!this.dialog.open) this.dialog.showModal();
        if (this.error) this.error.textContent = '';
        const list = TorrinsCompare.read();
        if (list.some((item) => !this.cache.has(item.handle))) {
          this.content.innerHTML = this.#skeleton(list.length);
          this.content.setAttribute('aria-busy', 'true');
        }
        await this.#load();
        this.content.removeAttribute('aria-busy');
        this.#render();
      }

      /** Placeholder table shown while the products load. */
      #skeleton(count) {
        const columns = Math.max(count, 2);
        const line = (width) => `<span class="torrins-compare-popup__bone" style="width: ${width}%"></span>`;
        const cells = (content) => Array.from({ length: columns }, () => `<td>${content}</td>`).join('');
        const labelCell = `<th class="torrins-compare-popup__label" scope="row">${line(70)}</th>`;
        const head = Array.from(
          { length: columns },
          () => `<th scope="col"><div class="torrins-compare-popup__product">
            <div class="torrins-compare-popup__media"><span class="torrins-compare-popup__bone torrins-compare-popup__bone--image"></span></div>
            ${line(90)}${line(60)}
          </div></th>`
        ).join('');
        const rows = [
          cells('<span class="torrins-compare-popup__bone torrins-compare-popup__bone--button"></span>'),
          cells(`${line(55)}${line(40)}`),
          cells(line(65)),
          cells(line(45)),
          cells(`${line(95)}${line(85)}${line(70)}`),
        ]
          .map((row) => `<tr>${labelCell}${row}</tr>`)
          .join('');
        return `
          <p class="torrins-compare-popup__status" role="status">
            <span class="torrins-compare-popup__spinner" aria-hidden="true"></span>
            Loading ${count} products…
          </p>
          <div class="torrins-compare-popup__scroll" aria-hidden="true">
            <table class="torrins-compare-popup__table torrins-compare-popup__table--loading" style="--torrins-compare-count: ${columns}">
              <thead><tr><th class="torrins-compare-popup__label" scope="col"></th>${head}</tr></thead>
              <tbody>${rows}</tbody>
            </table>
          </div>`;
      }

      close() {
        this.dialog?.close();
      }

      #onStoreChange = () => {
        if (this.dialog?.open) this.#render();
      };

      async #load() {
        const root = window.Shopify?.routes?.root || '/';
        const missing = TorrinsCompare.read().filter((item) => !this.cache.has(item.handle));
        await Promise.all(
          missing.map(async ({ handle }) => {
            try {
              const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=torrins-compare-product`);
              if (!response.ok) return;
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const data = html.querySelector('[data-compare-product]')?.textContent;
              if (data) this.cache.set(handle, JSON.parse(data));
            } catch {}
          })
        );
      }

      #render() {
        if (!this.content) return;
        const products = TorrinsCompare.read()
          .map((item) => this.cache.get(item.handle))
          .filter(Boolean);

        if (products.length === 0) {
          this.close();
          return;
        }

        const rows = [];
        const row = (label, cells) =>
          rows.push(
            `<tr><th scope="row" class="torrins-compare-popup__label">${escapeHtml(label)}</th>${cells
              .map((cell) => `<td>${cell}</td>`)
              .join('')}</tr>`
          );
        const dash = '<span class="torrins-compare-popup__muted">—</span>';

        row(
          '',
          products.map((p) => {
            const variants = (p.variants || []).filter((variant) => variant.available);
            if (!variants.length) {
              return `<button type="button" class="torrins-compare-popup__add" disabled>${escapeHtml(labels.soldOut)}</button>`;
            }
            const select =
              variants.length > 1
                ? `<select class="torrins-compare-popup__variant" data-compare-variant aria-label="${escapeHtml(p.title)}">${variants
                    .map((variant) => `<option value="${variant.id}">${escapeHtml(variant.title)} – ${escapeHtml(variant.price_money)}</option>`)
                    .join('')}</select>`
                : `<input type="hidden" data-compare-variant value="${variants[0].id}">`;
            return `<div class="torrins-compare-popup__cart">${select}<button type="button" class="torrins-compare-popup__add" data-compare-add>${escapeHtml(
              labels.add
            )}</button></div>`;
          })
        );

        row(
          'Price',
          products.map(
            (p) =>
              `<div class="torrins-compare-popup__price"><strong>${escapeHtml(p.price_money)}</strong>${
                p.compare_at_money ? `<s>${escapeHtml(p.compare_at_money)}</s>` : ''
              }</div>`
          )
        );

        if (products.some((p) => Number(p.rating) > 0)) {
          row(
            'Rating',
            products.map((p) => {
              const rating = Number(p.rating) || 0;
              if (!rating) return dash;
              const max = Number(p.rating_max) || 5;
              const full = Math.round((rating / max) * 5);
              return `<span class="torrins-compare-popup__stars" aria-label="${rating} / ${max}">${'★'.repeat(full)}${'☆'.repeat(
                5 - full
              )}</span> <span class="torrins-compare-popup__count">${rating.toFixed(1)}${
                p.rating_count ? ` (${escapeHtml(p.rating_count)})` : ''
              }</span>`;
            })
          );
        }

        row(
          'Availability',
          products.map((p) =>
            p.available
              ? '<span class="torrins-compare-popup__stock--in">In stock</span>'
              : `<span class="torrins-compare-popup__stock--out">${escapeHtml(labels.soldOut)}</span>`
          )
        );

        const optionNames = [...new Set(products.flatMap((p) => (p.options || []).map((option) => option.name)))];
        for (const name of optionNames) {
          row(
            name,
            products.map((p) => {
              const option = (p.options || []).find((entry) => entry.name === name);
              return option && option.values.length ? escapeHtml(option.values.join(', ')) : dash;
            })
          );
        }

        const specLabels = [...new Set(products.flatMap((p) => (p.specs || []).map((spec) => spec.label)))];
        for (const label of specLabels) {
          const specs = products.map((p) => (p.specs || []).find((spec) => spec.label === label));
          if (specs.every((spec) => !spec?.value)) continue;
          // Formatted metafield HTML (metafield_tag: lists, paragraphs) from the store's own data.
          row(
            label,
            specs.map((spec) =>
              spec?.value ? `<div class="torrins-compare-popup__spec">${spec.html || escapeHtml(spec.value)}</div>` : dash
            )
          );
        }

        const head = products
          .map(
            (p) => `
              <th scope="col">
                <div class="torrins-compare-popup__product">
                  <a class="torrins-compare-popup__image" href="${escapeHtml(p.url)}" tabindex="-1" aria-hidden="true">
                    ${p.image ? `<img src="${escapeHtml(p.image)}" alt="" loading="lazy" width="250" height="250">` : ''}
                  </a>
                  <button type="button" class="torrins-compare-popup__remove" data-compare-remove="${escapeHtml(p.handle)}" aria-label="Remove ${escapeHtml(p.title)}">&times;</button>
                  <a class="torrins-compare-popup__name" href="${escapeHtml(p.url)}">${escapeHtml(p.title)}</a>
                </div>
              </th>`
          )
          .join('');

        this.content.innerHTML = `
          <div class="torrins-compare-popup__scroll">
            <table class="torrins-compare-popup__table" style="--torrins-compare-count: ${products.length}">
              <thead><tr><th class="torrins-compare-popup__label" scope="col"><span class="visually-hidden">Product</span></th>${head}</tr></thead>
              <tbody>${rows.join('')}</tbody>
            </table>
          </div>`;
      }

      #onClick = async (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        // Click on the backdrop (outside the dialog box) or the × closes it.
        if (target === this.dialog || target.closest('[data-compare-close]')) {
          this.close();
          return;
        }

        const remove = target.closest('[data-compare-remove]');
        if (remove instanceof HTMLElement) {
          TorrinsCompare.remove(remove.dataset.compareRemove || '');
          return;
        }

        const add = target.closest('[data-compare-add]');
        if (!(add instanceof HTMLButtonElement) || add.getAttribute('aria-busy') === 'true') return;
        const field = add.closest('td')?.querySelector('[data-compare-variant]');
        const id = field instanceof HTMLSelectElement || field instanceof HTMLInputElement ? Number(field.value) : 0;
        if (!id) return;

        if (this.error) this.error.textContent = '';
        add.setAttribute('aria-busy', 'true');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          window.location.assign(`${root}cart`);
        } catch (err) {
          if (this.error) this.error.textContent = err instanceof Error ? err.message : String(err);
          add.removeAttribute('aria-busy');
        }
      };
    }

    function ensure(tag) {
      let element = document.querySelector(tag);
      if (!element) {
        element = document.createElement(tag);
        document.body.append(element);
      }
      return element;
    }
    const ensureBar = () => /** @type {TorrinsCompareBar} */ (ensure('torrins-compare-bar'));
    const ensurePopup = () => /** @type {TorrinsComparePopup} */ (ensure('torrins-compare-popup'));

    /* ---------- Toggle (card checkbox / product page button) ---------- */
    class TorrinsCompareToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        if (this.dataset.soldOutLabel) labels.soldOut = this.dataset.soldOutLabel;
        if (this.dataset.addLabel) labels.add = this.dataset.addLabel;
        this.input?.addEventListener('change', this.#onChange);
        // Card galleries can be slideshows that grab pointer/mouse down for swiping.
        for (const type of ['pointerdown', 'mousedown', 'touchstart']) {
          this.addEventListener(type, (event) => event.stopPropagation(), { passive: true });
        }
        document.addEventListener('torrins:compare-change', this.sync);
        this.sync();
        ensureBar();
        ensurePopup();
      }

      disconnectedCallback() {
        document.removeEventListener('torrins:compare-change', this.sync);
      }

      sync = () => {
        if (this.input) this.input.checked = TorrinsCompare.has(this.dataset.handle || '');
      };

      /** @returns {{h: string, t: string}[]} */
      #collections() {
        try {
          const list = JSON.parse(this.dataset.collections || '[]');
          return Array.isArray(list) ? list : [];
        } catch {
          return [];
        }
      }

      #onChange = () => {
        if (!this.input) return;
        const handle = this.dataset.handle || '';
        if (!this.input.checked) {
          TorrinsCompare.remove(handle);
          return;
        }
        const item = {
          handle,
          title: this.dataset.title || '',
          url: this.dataset.url || '',
          image: this.dataset.image || '',
          collections: this.#collections(),
        };
        const result = TorrinsCompare.add(item);
        if (result === 'full') {
          this.input.checked = false;
          ensureBar().showMessage(`You can compare up to ${MAX} products. Remove one first.`);
        } else if (result === 'collection') {
          this.input.checked = false;
          ensureBar().askReplace(item);
        }
      };
    }

    customElements.define('torrins-compare-bar', TorrinsCompareBar);
    customElements.define('torrins-compare-popup', TorrinsComparePopup);
    customElements.define('torrins-compare-toggle', TorrinsCompareToggle);

    // Keep checkboxes / bar in sync with other tabs and with back/forward cache.
    window.addEventListener('storage', (event) => {
      if (event.key === KEY) notify();
    });
    window.addEventListener('pageshow', notify);
  })();
  } catch(e) { console.error(e); }
})();

})();
